import {BUS_THANKYOU_JOURNEY_DETAIL,BUS_THANKYOU_STATUS_DETAIL,BUS_FEEDBACK_URL,BUS_SURVEY_URL} from '../../config/apiPoints';

export const prepareThankyouJourneyDetailsRequest = (params) => {
  const {flavour,
     payment,
    trn,
    vertical_txn_id,
    pay_txn_id,
    pay_session_id,
    pay_status,
    request_id,
    pg,
    format} = params;

  
  const query = `?flavour=${flavour}&payment=${payment}&trn=${trn}&vertical_txn_id=${vertical_txn_id}&pay_txn_id=${pay_txn_id}&pay_session_id=${pay_session_id}&pay_status=${pay_status}&request_id=${request_id}&pg=${pg}&format=${format}`;
  let url = `${__ENV_CONFIG__.__DEPOT__}${BUS_THANKYOU_JOURNEY_DETAIL}${query}`;
  
  return url;
};
export const prepareBookingStatusRequest = (params) => {
  const {flavour,
    trn,
    vertical_txn_id} = params;

  
  const query = `?flavour=${flavour}&trn=${trn}`;
  let url = `${__ENV_CONFIG__.__GOIBIBO__}${BUS_THANKYOU_STATUS_DETAIL}${query}`;
  
  return url;
};

export const prepareFeedbackStatusAPI = (params) => {
  const {vertical_txn_id} = params;

  const query = `${vertical_txn_id}`;
  let url = `${__ENV_CONFIG__.__NPS_SYSTEM__}${BUS_FEEDBACK_URL}${query}`; 
  return url;
};

export const prepareSurveyAPICall = (params) => {
  const {bookingId,bookingStatus,source,npsRating} = params;

  const query = `&bookingId=${bookingId}&bookingStatus=${bookingStatus}&source=${source}&npsRating=${npsRating}`;
  let url = `${__ENV_CONFIG__.__NPS_SYSTEM__}${BUS_SURVEY_URL}${query}`; 
  return url;
}